<template>
    <q-card>
        <q-toolbar>
            <q-toolbar-title class="text-center">
                Recover Password
            </q-toolbar-title>
        </q-toolbar>
        <q-separator />
        <form v-if="!done" @submit.prevent="recover">
            <q-card-section>
                <p class="text-subtitle1">
                    Please enter your email address below:
                </p>
                <q-input
                        label="Email"
                        type="email"
                        name="email"
                        v-model="email"
                        outlined
                />
            </q-card-section>
            <q-card-actions align="center">
                <async-btn
                        type="submit"
                        label="Recover"
                        :task="task"
                        color="primary"
                        class="full-width"
                />
            </q-card-actions>
        </form>
        <q-card-section v-else class="animated fadeIn">
            <message>
                An email has been sent to you with a link that
                will allow you to reset your password.
            </message>
        </q-card-section>
    </q-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Message from '@/components/message/Message.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import { recoverPassword } from './user';

interface Data {
  email: string,
  done: boolean,
  task: Promise<void>|null,
}

export default defineComponent({
  components: {
    Message,
    AsyncBtn,
  },
  data(): Data {
    return {
      email: '',
      done: false,
      task: null,
    };
  },
  methods: {
    recover() {
      this.task = recoverPassword(this.email);
      this.task.then(() => {
        this.done = true;
      });
    },
  },
});
</script>
